module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', {
    attrs: {
      "contextual-style": "primary"
    }
  }, [_c('h1', {
    staticClass: "panel-title",
    slot: "heading"
  }, [_vm._v("\n      My Account\n    ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n            First Name\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Last Name\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Email\n          ")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(_vm.$store.state.account.firstName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$store.state.account.lastName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$store.state.account.email) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_vm._v("\n      Total Users: " + _vm._s(_vm.usersCount) + "\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5021fe42"}!./src/app/pages/account/index/index.html
// module id = 224
// module chunks = 1